module.exports = __webpack_public_path__ + "static/media/phone.860877f9.svg";